// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___h2Ks","headerText":"styles_headerText__CuNgA","subHeaderText":"styles_subHeaderText__Oro0r","prefix":"styles_prefix__J5H4C"};